const Theme = {
	colors: {
		yellow: '#fddb51'
	}
};

export default Theme;